import useAuthenticatedApi from '../../Authentication/components/hooks/useAuthenticatedApi';

interface DeviceKeyActionsProps {
    orgId: number;
    row: any;
    onDelete: () => void;
    onRename: (deviceKey: DeviceKey) => void;
}

export default function DeviceKeyActions({
    orgId,
    row,
    onDelete,
    onRename,
}: DeviceKeyActionsProps) {
    const deviceKeyId = row.original.id;
    const authenticatedApi = useAuthenticatedApi();

    const performDelete = () => {
        const deleteRequest = async () => {
            const response = await authenticatedApi.delete(
                `${orgId}/device-keys/${deviceKeyId}`,
            );

            if (response.status === 200) {
                onDelete();
            }
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete ${row.original.name}`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };

    const performRename = () => {
        onRename(row.original);
    };

    return (
        <span className="Table-options">
            <i
                onClick={performRename}
                className="bi bi-pencil-fill mr-2 cursor-pointer hover:text-blue-600"
            ></i>
            <i
                onClick={performDelete}
                className="bi bi-trash3-fill cursor-pointer hover:text-red-600"
            ></i>
        </span>
    );
}
